<template>
  <div class="onboarding-first-step">
    <h1 class="onboarding-first-step__message">
      {{ $t('components.Onboarding.label.title.firstStepMessage') }}
    </h1>
    <p class="onboarding-first-step__required-message">
      {{ $t('components.Onboarding.label.title.requiredMessage') }}
    </p>

    <div class="onboarding-first-step__selectors">
      <div>
        <v-autocomplete
          v-model="onboardingData.department"
          :items="departmentItens"
          :label="$t('components.Onboarding.label.title.department')"
          :rules="isNotEmptyRule"
          dense
          required
          outlined
        />

        <v-text-field
          v-if="isDepartmentOthersSelected"
          v-model="onboardingData.otherDepartment"
          class="mt-4"
          :label="$t('components.Onboarding.label.title.newDepartment')"
          :rules="isNotEmptyRule"
          outlined
          required
          dense
        />
      </div>

      <div class="mt-8">
        <v-autocomplete
          v-model="onboardingData.job"
          :items="jobItens"
          :label="$t('components.Onboarding.label.title.job')"
          :rules="isNotEmptyRule"
          dense
          required
          outlined
        />
        <v-text-field
          v-if="isJobOthersSelected"
          v-model="onboardingData.otherJob"
          class="mt-4"
          :label="$t('components.Onboarding.label.title.newJob')"
          :rules="isNotEmptyRule"
          outlined
          required
          dense
        />
      </div>
    </div>
  </div>
</template>

<script>
import { JOB_LIST, DEPARTMENT_LIST } from '@/utils/constants';

export default {
  name: 'OnboardingUserAndCompany',
  props: {
    onboardingData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      departmentItens: DEPARTMENT_LIST,
      jobItens: JOB_LIST,
      isNotEmptyRule: [
        value => Boolean(value),
      ],
    };
  },
  computed: {
    others() {
      return this.$t('components.Onboarding.label.title.others');
    },
    isDepartmentOthersSelected() {
      this.clearOthersDepartmentField();
      return this.onboardingData.department === this.others;
    },
    isJobOthersSelected() {
      this.clearOthersJobsField();
      return this.onboardingData.job === this.others;
    },
  },
  created() {
    this.jobItens.push(this.others);
    this.departmentItens.push(this.others);
  },
  methods: {
    clearOthersDepartmentField() {
      this.onboardingData.otherDepartment = this.onboardingData.department === this.others ? this.onboardingData.otherDepartment : '';
    },
    clearOthersJobsField() {
      this.onboardingData.otherJob = this.onboardingData.job === this.others ? this.onboardingData.otherJob : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-first-step {
    &__message {
      color: #000;
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      line-height: var(--ds-font-line-height-normal);
    }

    &__required-message {
      color: var(--ds-color-text-2);
      margin-top: var(--ds-spacing-stack-nano);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
    }

    &__selectors {
      display: flex;
      flex-direction: column;
      width: 287px;
      margin-top: var(--ds-spacing-stack-sm);
    }
  }

  ::v-deep {
    .v-list-item {
      max-width: 276px !important;
    }

    .v-text-field__details {
      display: none;
    }
  }

</style>
